/**
 * The PUT of a file to a presigned bucket URL — the SPA's second request that carries neither
 * the org header nor a cookie. `edge.ts`'s header carries the rule this obeys.
 *
 * **This request is legitimately for no organisation.** The URL is a capability the API signed
 * for one object key, and the key already holds the tenancy (§12). Sending
 * `x-packagepage-org` would hand the bucket's host a tenant id it has no use for, and
 * `credentials: "omit"` keeps the session cookie on the origin that issued it.
 */

/** Resolves when the bucket stored the bytes. Rejects with the status when it refused them. */
export async function putToPresignedUrl(
  upload: { readonly url: string; readonly method: "PUT" },
  file: Blob,
): Promise<void> {
  const response = await fetch(upload.url, {
    method: upload.method,
    body: file,
    credentials: "omit",
    headers: file.type === "" ? {} : { "Content-Type": file.type },
  });
  if (!response.ok) {
    throw new Error(`the bucket refused the upload: ${String(response.status)}`);
  }
}
